import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;


export const getAbsentTeachersSvc = (fromDt, toDt, callback) => {
    // // console.log("getAbsentTeachersSvc called");
    const formData = new FormData();
    formData.append("fromDt", fromDt);
    formData.append("toDt", toDt);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/subs_report/absent_teachers',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
        data: formData
    }).then((response) => {
        // // console.log('response in getAbsentTeachersSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchAbsent = response.data.lstTchSubsDuty || [];
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}